import cookie from 'react-cookies';
import actionTypes from '../actionTypes';

export const setLoggedIn = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SET_LOGGED_IN,
    });
  };
};

export const logout = () => {
  cookie.remove('token', {
    path: '/',
  });

  return (dispatch) => {
    dispatch({
      type: actionTypes.AUTH_LOGOUT,
    });
  };
};

export const login = (email, password) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.AUTH_LOGIN_REQUEST,
      email,
      password,
    });
  };
};

export const signup = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.AUTH_SIGNUP_REQUEST,
      ...data,
    });
  };
};

export const forgotPassword = (email) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.AUTH_FORGOT_REQUEST,
      email,
    });
  };
};

export const retrieveEmail = (uid, token) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.AUTH_EMAIL_REQUEST,
      token,
      uid,
    });
  };
};

export const resetPassword = (token, uid, password) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.AUTH_RESET_REQUEST,
      token,
      uid,
      password,
    });
  };
};

export const getConfirmEmail = (token) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.AUTH_CONFIRM_EMAIL_REQUEST,
      token,
    });
  };
};

export const verifyEmailByToken = (token) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.AUTH_VERIFY_EMAIL_REQUEST,
      token,
    });
  };
};

export const resendConfirmationLink = (email) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESEND_CONFIRMATION_LINK_REQUEST,
      email,
    });
  };
};



// WEBPACK FOOTER //
// src/redux/actions/auth.js